import { useState, type FormEvent } from "react";
import { supabase } from "../lib/supabase";
import styles from "./Login.module.css";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setErr(traduzErro(error.message));
    setBusy(false);
  }

  return (
    <div className={styles.shell}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <img src="/logo-reach-up.png" alt="Reach Up" className={styles.logo} width={150} height={58} />
        </div>
        <h1 className={styles.title}>Sucesso do Cliente</h1>
        <p className={styles.sub}>
          Ferramenta interna da equipe. Acesso restrito a contas @reachup.pro.
        </p>

        <form onSubmit={onSubmit} className={styles.form}>
          <label className="field">
            <span>E-mail</span>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={busy}
              placeholder="voce@reachup.pro"
            />
          </label>
          <label className="field">
            <span>Senha</span>
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={busy}
            />
          </label>

          {err && <p className={styles.err}>{err}</p>}

          <button type="submit" disabled={busy} className="btn btn-primary">
            {busy ? "Entrando…" : "Entrar"}
          </button>
        </form>

        <p className={styles.note}>
          Sem conta? Peça um convite ao administrador. Usuários são criados manualmente.
        </p>
      </div>
    </div>
  );
}

function traduzErro(msg: string): string {
  if (/invalid login credentials/i.test(msg)) return "E-mail ou senha incorretos.";
  if (/email not confirmed/i.test(msg)) return "E-mail ainda não confirmado.";
  return msg;
}
